import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { THEME_TYPE } from '@config/global-constants';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private themeObject: { theme: string };
    private http: HttpClient;

    public constructor(httpBackend: HttpBackend) {
        this.http = new HttpClient(httpBackend);
    }

    public fetchTheme(): Promise<void> {
        return this.http
            .get<{ theme: string }>(`${environment.portalBackendURI}/global-preferences/theme`, {})
            .toPromise()
            .then((theme: { theme: string }): void => {
                this.themeObject = theme;
                this.applyTheme(this.themeObject?.theme);
            });
    }

    public getTheme(): string {
        return this.themeObject?.theme;
    }

    private applyTheme(theme: string) {
        const themeToSet = theme === THEME_TYPE.GENIUS ? THEME_TYPE.GENIUS : THEME_TYPE.XENIAL;
        const root = document.documentElement;
        root.className = '';
        root.classList.add(`theme-${themeToSet}`);
    }
}
